import { route } from 'preact-router';
import { identifyUserActionType, ntbActionType } from '../../actionTypes';
import { lenderListController } from '../../api/controllers/ntbController';
import { removeBlankKeys } from '../../components/material-ui/helper';
import {
  newUserActivationSuccessPageRoute,
  newUserActivationPreapprovedSuccessPageRoute,
  offlineStoresEligibilePageRoute,
  offlineStoresNotEligibleRoute,
  campaignUserActivationPreapprovedSuccessPageRoute,
  campaignUserNotEligible,
  ntbApplicationRoute,
} from '../../alias/homeRoutes';
import { addUtmParams } from '../../utils/helper';
import Utils from '../../utils';
import { iciciLenderId } from '../../constants';

export const verifyOTPSuccessAction = (responseData) => (dispatch) => {
  const {
    message,
    mobile,
    redirectUrl,
    isNTBEnabledOnMerchant,
    utmSource,
    utmMedium,
    campaignId,
    utmContent,
    utmTerm,
    channel,
    samePage,
    variant,
    variation,
    urls,
    merchantId,
  } = responseData || {};
  const data = {
    mobile: mobile,
    redirectUrl: redirectUrl,
  };
  const utmParamsAvailable =
    utmSource || utmMedium || campaignId || utmContent || utmTerm;

  const iciciSubDomainNonEligibleFlowCheck = (lenderDetailsList) => {
    if (Utils.isIciciSubDomain() && lenderDetailsList) {
      //if the user is on icici subdomain and is not pre approved with the same lender then alter the behaviour on the campaign page
      const iciciArr = lenderDetailsList.filter(
        (lender) => lender.lenderId == iciciLenderId,
      );
      return iciciArr.length ? false : true;
    }
    return false;
  };

  const getRoute = (channel) => {
    switch (channel) {
      case 'OFFLINE':
        return {
          eligiblePath: `${offlineStoresEligibilePageRoute.path}${
            utmParamsAvailable
              ? `?success=true${addUtmParams(
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                )}`
              : ''
          }`,
          notEligiblePath: `${offlineStoresNotEligibleRoute.path}${
            utmParamsAvailable
              ? `?success=false${addUtmParams(
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                )}`
              : ''
          }`,
        };
      case 'CAMPAIGN_LANDING_PAGE':
        return {
          eligiblePath: `${
            campaignUserActivationPreapprovedSuccessPageRoute.path
          }${
            utmParamsAvailable
              ? `?success=true${
                  merchantId ? `&merchantId=${merchantId}` : ''
                }${addUtmParams(
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                )}${variation ? `&var=${variation}` : ''}`
              : `${variation ? `?var=${variation}` : ''}${
                  merchantId ? `&merchantId=${merchantId}` : ''
                }`
          }`,
          notEligiblePath: `${
            isNTBEnabledOnMerchant
              ? ntbApplicationRoute.path
              : campaignUserNotEligible.path
          }${
            utmParamsAvailable || merchantId
              ? `?success=false${
                  isNTBEnabledOnMerchant
                    ? merchantId
                      ? `&merchantId=${merchantId}`
                      : ''
                    : ''
                }${addUtmParams(
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                )}${variation ? `&var=${variation}` : ''}`
              : `${variation ? `?var=${variation}` : ''}`
          }`,
        };

      default:
        return {
          eligiblePath: `${newUserActivationPreapprovedSuccessPageRoute.path}${
            utmParamsAvailable
              ? `?success=true${addUtmParams(
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                )}`
              : ''
          }`,
          notEligiblePath: `${
            isNTBEnabledOnMerchant
              ? ntbApplicationRoute.path
              : newUserActivationSuccessPageRoute.path
          }?isNTBEnabledOnMerchant=${isNTBEnabledOnMerchant}${
            isNTBEnabledOnMerchant
              ? merchantId
                ? `&merchantId=${merchantId}`
                : ''
              : ''
          }${
            utmParamsAvailable
              ? addUtmParams(
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                )
              : ''
          }`,
        };
    }
  };
  const getUrlPath = (urls) => {
    if (urls) {
      return {
        eligiblePath: `${urls.successUrl}${
          utmParamsAvailable
            ? `?success=true${addUtmParams(
                utmSource,
                utmMedium,
                campaignId,
                utmContent,
                utmTerm,
              )}`
            : ''
        }`,
        notEligiblePath: `${urls.nonapprovedUrl}${
          utmParamsAvailable
            ? `?success=false${addUtmParams(
                utmSource,
                utmMedium,
                campaignId,
                utmContent,
                utmTerm,
              )}`
            : ''
        }`,
      };
    }
    return {
      eligiblePath: getRoute(channel).eligiblePath,
      notEligiblePath: getRoute(channel).notEligiblePath,
    };
  };
  if (!(message === 'success')) {
    const errorMessage = message;
    dispatch({
      type: ntbActionType.VERIFY_OTP_FAILURE,
      payload: { errorMessage },
    });
  } else {
    dispatch({ type: ntbActionType.LENDER_LIST_REQUEST, payload: {} });
    lenderListController(data)
      .then(({ data: responseData }) => {
        const { eligible, status, lenderDetailsList } = responseData || {};
        dispatch({
          type: ntbActionType.LENDER_LIST_SUCCESS,
          payload: removeBlankKeys({ eligible }),
        });
        dispatch({
          type: ntbActionType.INIT_LENDER_LIST_SCREEN,
          payload: {
            ...responseData,
            mobileNo: mobile,
            redirectUrl: redirectUrl,
            isNTBEnabledOnMerchant,
          },
        });

        dispatch({
          type: identifyUserActionType.IDENTIFY_USER_AUTH_SET,
          payload: {
            mobile,
          },
        });

        const isIciciSubDomainNonEligibleFlow = iciciSubDomainNonEligibleFlowCheck(
          lenderDetailsList,
        );

        !isIciciSubDomainNonEligibleFlow &&
          dispatch({
            type: ntbActionType.CLOSE_OTP_OVERLAY_SCREEN,
            payload: {},
          });

        dispatch({ type: ntbActionType.CLOSE_OVERLAY_SCREEN, payload: {} });

        return setTimeout(() => {
          if (
            status === 'REGISTERED' ||
            status === 'PRE_APPROVED' ||
            status === 'ACTIVE'
          ) {
            if (isIciciSubDomainNonEligibleFlow) {
              return dispatch({
                type: ntbActionType.USER_STATUS,
                payload: { userStatus: 'notEligibleIcici' },
              });
            }

            return samePage
              ? dispatch({
                  type: ntbActionType.USER_STATUS,
                  payload: { userStatus: 'eligible' },
                })
              : route(getUrlPath(urls).eligiblePath, true);
          } else {
            return samePage
              ? dispatch({
                  type: ntbActionType.USER_STATUS,
                  payload: { userStatus: 'notEligible' },
                })
              : route(getUrlPath(urls).notEligiblePath, false);
          }
        });
      })
      .catch((error) => {
        dispatch({
          type: ntbActionType.LENDER_LIST_FAILURE,
          payload: removeBlankKeys({ message }),
        });
      });
  }
};



// WEBPACK FOOTER //
// ./actions/ntbAction/verifyOTPSuccessAction.js